<template>
  <vs-popup class="formula_application_manage_popup"
            id="popup"
            title="FORMULATIONS APPLICATION MANAGE"
            @close="open = false"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>

      <div  id="formulation_qa_table">
      <div class="vx-row" id="">
        <div class="vx-col w-full">
          <vx-card no-shadow>

            <template slot="actions">
              <vs-button @click="applicationCreatePopOpActive = true"  class="mr-0" color="primary" size="small" type="filled">CREATE</vs-button>
            </template>

            <div slot="no-body" class="mt-4">
              <vs-table  :data="applications"  :sst="true" stripe class="table-dark-inverted table-auto vs-con-loading__container">

                <template slot="thead">
                  <vs-th width="25%" sort-key="contact_1">NAME</vs-th>
                  <vs-th width="25%" class="float-left">DESCRIPTION</vs-th>
                  <vs-th width="25%" sort-key="email">CODE</vs-th>
                  <vs-th width="15%">ACTIVE STATUS</vs-th>
                  <vs-th width="10%">ACTION</vs-th>
                </template>

                <template slot-scope="{data}">
                  <vs-tr  :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td :data="data[indextr].name">
                      {{ data[indextr].name  }}
                    </vs-td>
                    <vs-td :data="data[indextr].description">
                      {{ data[indextr].description }}
                    </vs-td>

                    <vs-td :data="data[indextr].code">
                      {{ data[indextr].code }}
                    </vs-td>

                    <vs-td :data="data[indextr].description">
                      <!--                    {{ data[indextr].is_active }}-->
                      <vs-chip transparent v-if="data[indextr].is_active"  color="primary">
                        active
                      </vs-chip>
                      <vs-chip transparent v-if="!data[indextr].is_active"  color="warning">
                        dea-ctive
                      </vs-chip>
                    </vs-td>
                    <vs-td>
                      <div class="vx-row">
                        <vx-tooltip text="Update" position="left">
                          <vs-button @click="onClickApplicationUpdatePopUp(data[indextr].id)"
                                     size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit"></vs-button>
                        </vx-tooltip>
                        <vx-tooltip text="Delete" position="left">
                          <vs-button class="ml-3" @click="onClickApplicationDelete(data[indextr].id)"
                                     size="small" color="danger" type="border" icon-pack="feather" icon="icon-delete"></vs-button>
                        </vx-tooltip>
                      </div>
                    </vs-td>
                  </vs-tr>
                </template>


              </vs-table>
            </div>

          </vx-card>
        </div>
      </div>

      </div>


    </vx-card>
    <!--    application update popup-->
    <vs-popup title="APPLICATION UPDATE" :active.sync="applicationUpdatePopOpActive">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="formular_application_update_popup" @submit.prevent="handleSubmit(onClickUpdateFormular)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input readonly="" v-model="selectedApplication.name"   name="name" class="w-full required" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="required" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="selectedApplication.description" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="code" name="code" rules="required" v-slot="{ errors }">
                <small class="label">Code</small>
                <vs-input  v-model="selectedApplication.code"   name="code" class="w-full required" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div v-if="!!selectedApplication.parent_id" class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="parent_id" name="parent_id" rules="required" v-slot="{ errors }">
                <small class="label">Parent</small>
                <v-select name="parent_id"  label="name" v-model="selectedApplication.parent_id" :reduce="option => option.id" :options="first_tier_applications" :dir="$vs.rtl ? 'rtl' : 'ltr'">
<!--                  <template v-slot:option="option">-->
<!--                    <span>{{option.code}} - {{option.name}}</span>-->
<!--                  </template>-->
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vs-popup>
    <!--    application update popup-->

    <!--    application create popup-->
    <vs-popup class="formular_application_create_popup" title="APPLICATION CREATE" :active.sync="applicationCreatePopOpActive">
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form id="formular_application_create_popup" @submit.prevent="handleSubmit(onClickCreateFormular)" autocomplete="off">
          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full md:mb-0">
              <ValidationProvider vid="name" name="name" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input  v-model="selectedApplication.name"   name="name" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="description" name="description" rules="required" v-slot="{ errors }">
                <small class="label">Description</small>
                <vs-textarea class="mb-0" v-model="selectedApplication.description" height="100px" />
                <span class="text-danger text-xs mt-0">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col w-full">
              <ValidationProvider vid="code" name="code" rules="required" v-slot="{ errors }">
                <small class="label">Code</small>
                <vs-input  v-model="selectedApplication.code"   name="code" class="w-full required" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
          </div>

          <div class="vx-row mb-3">
            <div class="vx-col md:w-full w-full">
              <ValidationProvider vid="parent_id" name="parent_id" rules="" v-slot="{ errors }">
                <small class="label">Parent</small>
                <v-select name="parent_id"  label="name" v-model="selectedApplication.parent_id" :reduce="option => option.id" :options="first_tier_applications" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                  <!--                  <template v-slot:option="option">-->
                  <!--                    <span>{{option.code}} - {{option.name}}</span>-->
                  <!--                  </template>-->
                </v-select>
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
          </div>
          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2">Save Changes</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vs-popup>
    <!--    application create popup-->

  </vs-popup>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  const FormulationsRepository = RepositoryFactory.get('formulations')
  import { VTree, VSelectTree}  from 'vue-tree-halower'
  import {TreeViewPlugin} from "@syncfusion/ej2-vue-navigations";
  import Vue from "vue";
  import vSelect from 'vue-select'

  Vue.use(TreeViewPlugin);

  function initialState() {
    return {
      open: false,
      applicationUpdatePopOpActive: false,
      applicationCreatePopOpActive: false,
      id: '',
      applications: [],
      treeData: [],
      fields:{},
      formulation: {},
      selected_applications: [],
      first_tier_applications: [],
      selectedApplication: {}
    }
  }

export default {
  name: 'FormulationApplicationManagePopUp',
  data () {
    return initialState()
  },
  methods:{
    async openPopup (id) {
      try {
        await Object.assign(this.$data, initialState())
        this.id = id
        // await this.loadFormulations()
        await this.loadFormulationsApplications()
        this.open = true
      } catch (error) {
        this.$vs.loading.close()
      }
    },

    async loadFormulations() {
      await this.$vs.loading()
      const {data} = await FormulationsRepository.details(this.id)
      this.formulation =  data.data
      this.formulation.application_items.forEach((m) => {
        this.selected_applications.push(m.id)
      })
      this.$vs.loading.close()
    },

    async loadFormulationsApplications() {
      await this.$vs.loading({
        container: '#formulation_qa_table',
        scale: 0.45
      })
      const {data} = await FormulationsRepository.getFormulaApplications()
      this.applications =  data.data
      this.first_tier_applications = this.applications.filter((m) => {
        return !m.parent_id
      })
      this.first_tier_applications.push({id: null, name: 'null'})

      this.$vs.loading.close('#formulation_qa_table > .con-vs-loading')
    },
    async onClickUpdateFormulaApplication() {
      const vue = this;
      try {
        await this.$vs.loading({
          container: '#formulation_qa_table',
          scale: 0.45
        })
        await FormulationsRepository.updateFormulationsNote(this.id, {
          batch_weight: this.formulation.batch_weight,
          notes: this.formulation.notes,
          application_items: this.selected_applications
        })
        this.showSuccessMessage('Formulation applications updated');
        await vue.$parent.refreshData()
        this.open = false
      } catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#formulation_qa_table > .con-vs-loading')
    },
    async onClickApplicationUpdatePopUp(id) {
      this.applicationUpdatePopOpActive = true
      await this.$vs.loading({
        container: '#formular_application_update_popup',
        scale: 0.45
      })
      const {data} = await FormulationsRepository.getFormulaApplicationDetails(id)
      this.selectedApplication =  data.data

      this.$vs.loading.close('#formular_application_update_popup > .con-vs-loading')
    },
    async onClickUpdateFormular() {
      await this.$vs.loading({
        container: '#formular_application_update_popup',
        scale: 0.45
      })
      try {
        const {data} = await FormulationsRepository.formularApplicationUpdate(this.selectedApplication.id, this.selectedApplication)
        this.showSuccessMessage('Formulation applications updated');
        this.selectedApplication = {}
        this.applicationUpdatePopOpActive = false
        await this.loadFormulationsApplications()
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#formular_application_update_popup > .con-vs-loading')
    },
    async onClickCreateFormular() {
      await this.$vs.loading({
        container: '#formular_application_create_popup',
        scale: 0.45
      })
      try {
        const {data} = await FormulationsRepository.formularApplicationCreate(this.selectedApplication)
        this.showSuccessMessage('Formulation applications created');
        this.selectedApplication = {}
        this.applicationCreatePopOpActive = false
        await this.loadFormulationsApplications()
      }catch (e) {
        this.convertAndNotifyError(e)
      }
      this.$vs.loading.close('#formular_application_create_popup > .con-vs-loading')
    }
  },
  async mounted () {

  },
  components: {
    VTree,
    VSelectTree,
    'v-select': vSelect,
  },
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  /*@import "@/assets/scss/vuexy/extraComponents/tree.scss";*/

  .formula_application_manage_popup >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 60% !important;
  }
  .formular_application_create_popup >>> .vs-popup {
    min-height: 60% !important;
    /*min-width: 60% !important;*/
  }


  button.btn-async{
    background: rgba(var(--vs-warning),0.15);
  }

  button.btn-delete{
    background: rgba(var(--vs-danger),0.15);
  }
</style>
